import adminRequest from "@/api/adminRequest";

export function clearDeletedAlarms(data) {
    return adminRequest({
        url: '/manage-alarms/clear-deleted',
        method: "post",
        data
    });
}

export function getRepeatableCandidates() {
    return adminRequest({
        url: '/manage-alarms/repeatable-candidates',
        method: "get",
    });
}